import angular from "angular"

import "./lista-alumnos.component.css"
const templateUrl = require("ngtemplate-loader!html-loader!./lista-alumnos.component.html")

ListaAlumnosController.$inject = [
  "appRoutesService",
  "formularioService",
  "ImportService",
  "apiService",
  "DTOptionsBuilder",
  "DTColumnDefBuilder",
  "$timeout",
  "$rootScope",
  "store"
]

function ListaAlumnosController(
  appRoutesService,
  formularioService,
  ImportService,
  apiService,
  DTOptionsBuilder,
  DTColumnDefBuilder,
  $timeout,
  $rootScope,
  store
) {
  var self = this

  self.COLUMNS_WITHOUT_FILTERS = ["alertas", "atenciones", "deserción"]

  self.rows = []
  self.recordsPerPage = 50
  self.currentPage = 1
  self.tableReady = false
  self.check_verde = true
  self.check_amarillo = true
  self.check_rojo = true

  self.columns = [
    {
      key: "cedula",
      value: "cédula",
      filter: "",
      model: true
    },
    {
      key: "alumno",
      value: "nombre",
      filter: "",
      model: true
    },
    {
      key: "sede",
      value: "sede",
      filter: "",
      model: true
    },
    {
      key: "carrera",
      value: "carrera",
      filter: "",
      model: true
    },
    {
      key: "estado",
      value: "estado",
      filter: "",
      model: true
    },
    {
      key: "atenciones",
      value: "atenciones",
      filter: "",
      type: "number"
    },
    {
      key: "alertas",
      value: "alertas",
      filter: "",
      type: "number"
    },
    {
      key: "desercion",
      value: "deserción",
      filter: "",
      type: "number"
    }
  ]

  self.getColumnClass = function(row, key) {
    var value
    if (key === "atributos.decil_riesgo") {
      value = row["atributos"]["decil_riesgo"]
      if (value < 5) {
        return "'semaforo_verde'"
      } else if (value < 9) {
        return "'semaforo_amarillo'"
      } else {
        return "'semaforo_rojo'"
      }
    }
    return ""
  }

  self.getColumnValue = function(row, key) {
    if (key === "desercion") {
      if (Number.isFinite(row[key])) {
        return (row[key] * 100).toFixed() + "%"
      } else {
        return ""
      }
    }

    var value
    var keys = key.split(".")
    for (var i = 0; i < keys.length; i++) {
      if (value === undefined) {
        value = row[keys[i]]
      } else {
        value = value[keys[i]]
        if (keys[i] === "decil_riesgo") {
          if (value < 5) {
            value = "BAJO"
          } else if (value < 9) {
            value = "MEDIO"
          } else {
            value = "ALTO"
          }
        }
      }
    }
    return value
  }

  self.change_check_semaforo = function() {
    self.queryData()
  }

  self.check_semaforo_state = function() {
    var value
    if (self.check_verde && self.check_amarillo && self.check_rojo) {
      value = "1-10"
    } else if (self.check_verde && self.check_amarillo) {
      value = "1-8"
    } else if (self.check_amarillo && self.check_rojo) {
      value = "5-10"
    } else if (self.check_verde && self.check_rojo) {
      value = "1-10"
    } else if (self.check_verde) {
      value = "1-4"
    } else if (self.check_amarillo) {
      value = "5-8"
    } else if (self.check_rojo) {
      value = "9-10"
    }

    return value
  }

  self.alertaMasiva = function($event) {
    if (self.validateSelection()) {
      formularioService.showPopup(
        $event,
        {
          modelName: "alertas",
          actionName: "crear"
        },
        {
          saveCallback: self.onCreateAlerta
        }
      )
    } else {
      formularioService.showAlert($event, "no_selection")
    }
  }

  self.atencionMasiva = function($event) {
    if (self.validateSelection()) {
      formularioService.showPopup(
        $event,
        {
          modelName: "atenciones",
          actionName: "crear"
        },
        {
          saveCallback: self.onCreateAtencion
        }
      )
    } else {
      formularioService.showAlert($event, "no_selection")
    }
  }

  self.cambiarEstado = function($event) {
    if (self.validateSelection()) {
      formularioService.showPopup(
        $event,
        {
          modelName: "matricula",
          actionName: "estado"
        },
        {
          saveCallback: self.onCambiarEstado,
          alumno: 0
        }
      )
    } else {
      formularioService.showAlert($event, "no_selection")
    }
  }

  self.showDNIsForm = function($event) {
    formularioService.showPopup(
      $event,
      {
        modelName: "studentslist",
        actionName: "copy"
      },
      {
        saveCallback: self.onCambiarEstado,
        alumno: 0
      }
    )
  }

  self.validateSelection = function() {
    return self.getSelection().length > 0
  }

  self.onMultipleOperation = function(post_data, callback, method_name) {
    var matriculas_params
    var data

    if (self.selectedAll) {
      matriculas_params = self.getTableState()
      if (matriculas_params.estado) {
        matriculas_params["estado_matricula"] = matriculas_params.estado
      }
    } else {
      matriculas_params = { ids: self.getSelection() }
    }

    data = Object.assign(post_data, matriculas_params)

    ImportService[method_name](data).then(function() {
      self.queryData(false)
      if (callback) {
        callback()
      }
    })
  }

  self.onCreateAlerta = function(post_data, callback) {
    self.onMultipleOperation(post_data, callback, "importAlertas")
  }

  self.onCreateAtencion = function(post_data, callback) {
    self.onMultipleOperation(post_data, callback, "importAtenciones")
  }

  self.onCambiarEstado = function(post_data, callback) {
    self.onMultipleOperation(post_data, callback, "importEstadosMatricula")
  }

  self._getmodels = function(params) {
    return apiService.getMatriculas(params)
  }

  self.$onInit = function() {
    self.cancelSorting()
    self.queryData()
  }

  self.selected = {}

  self.toggleSelectedRow = function(row_id) {
    self.selectedAll = self.areChecked()
  }

  self.selectedAll = false

  self.toggleSelectAll = function() {
    for (var i = 0; i < self.rows.length; i++) {
      self.rows[i].isSelected = self.selectedAll
    }
  }

  self.areChecked = function() {
    var total = self.rows.length
    var countSelected = 0
    var conjunction = true
    for (var i = 0; i < self.rows.length; i++) {
      if (self.rows[i].isSelected) {
        countSelected += 1
      }
      conjunction = conjunction && self.rows[i].isSelected
    }

    return conjunction && total == countSelected
  }

  self.getSelection = function(propertiesCallback) {
    var selected = []

    if (!propertiesCallback) {
      propertiesCallback = function(row) {
        return row.id
      }
    }

    for (var i = 0; i < self.rows.length; i++) {
      if (self.rows[i].isSelected) {
        selected.push(propertiesCallback(self.rows[i]))
      }
    }
    return selected
  }

  self.dtOptions = DTOptionsBuilder.newOptions()
    .withLanguage({
      sProcessing: "Buscando estudiantes...",
      sLengthMenu: "Mostrar _MENU_ registros",
      sZeroRecords: "No se encontraron resultados",
      sEmptyTable: "No se encontraron resultados",
      sInfo: "_START_ a _END_ de _TOTAL_",
      sInfoEmpty: "",
      sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
      sInfoPostFix: "",
      sSearch: "",
      sUrl: "",
      sInfoThousands: ".",
      sLoadingRecords: "Cargando...",
      oPaginate: {
        sFirst: "|<",
        sLast: ">|",
        sNext: ">",
        sPrevious: "<"
      },
      oAria: {
        sSortAscending: ": Activar para ordenar la columna de manera ascendente",
        sSortDescending: ": Activar para ordenar la columna de manera descendente"
      }
    })
    .withPaginationType("simple")
    .withDisplayLength(self.recordsPerPage)
    .withOption("scrollY", "60vh")
    .withOption("scrollX", "100%")
    .withDOM("t")

  self.cancelSorting = function() {
    var total_columnas = self.columns.length
    for (var i = 0; i < total_columnas + 2; i++) {
      self.dtColumnDefs.push(DTColumnDefBuilder.newColumnDef(i).notSortable())
    }
  }

  self.dtColumnDefs = []

  self.dtInstance = {}

  self.reloadTable = function() {
    self.tableReady = false
    $timeout(function() {
      self.dtInstance.rerender()
      self.tableReady = true
    }, 0)
    self.selectedAll = false
  }

  self.prevPage = function() {
    if (self.currentPage > 1) {
      self.currentPage -= 1
      self.queryData()
    }
  }

  self.nextPage = function() {
    if (self.recordsLeft > 0) {
      self.currentPage += 1
      self.queryData()
    }
  }

  self.filterChange = function(column) {
    if (column.key !== "atributos.decil_riesgo") {
      self.queryData(true)
      for (var i = 0; i < self.columns.length; i++) {
        self.columns[i]["focus"] = false
      }
      column["focus"] = true
    }
  }

  $rootScope.$on("onDNIListChange", function(event, dniList) {
    console.log(dniList)
    self.filterChangeByDniList(dniList)
  })

  self.filterChangeByDniList = function(dniList) {
    self.columns[0].filter = dniList
    self.queryData(true)
  }

  self.collectColumnParams = function() {
    var atributos = {}
    var sorting = []

    var result = {}
    var total_columnas = self.columns.length

    for (var i = 0; i < total_columnas; i++) {
      if (self.columns[i]["filter"] !== undefined) {
        if (self.columns[i]["filter"].trim() !== "") {
          if (!self.columns[i].model) {
            atributos[self.columns[i]["key"].replace("atributos.", "")] = {
              value: self.columns[i]["filter"].trim(),
              type: self.columns[i]["type"]
            }
          } else {
            result[self.columns[i]["key"]] = self.columns[i]["filter"].trim()
          }
        }
      }

      if (self.columns[i]["sort"] !== undefined && self.columns[i]["sort"] !== null) {
        sorting.push({
          key: self.columns[i]["key"],
          value: self.columns[i]["sort"]
        })
      }
    }

    result["atributos"] = atributos
    result["sorting"] = sorting
    return result
  }

  self.sortBy = function(column) {
    if (column.sort === undefined || column.sort === null) {
      column.sort = "asc"
    } else {
      if (column.sort === "asc") {
        column.sort = "desc"
      } else {
        column.sort = "asc"
      }
    }

    for (var i = 0; i < self.columns.length; i++) {
      if (self.columns[i]["key"] !== column.key) {
        self.columns[i]["sort"] = null
      }
    }

    self.queryData(true)
  }

  self.queryData = function(reset_page) {
    if (reset_page) {
      self.currentPage = 1
    }
    var params = self.getTableState()

    var check_semaforo_value = self.check_semaforo_state()

    if (check_semaforo_value) {
      if (params["atributos"] === undefined) {
        params["atributos"] = {}
      }
      params["atributos"]["decil_riesgo"] = {
        type: "number",
        value: check_semaforo_value
      }
    }

    delete params["atributos"]

    self._getmodels(params).then(function(data) {
      self.rows = data.results
      self.showing = data.results.length
      self.full_count = data.count
      self.start_index = (self.currentPage - 1) * self.recordsPerPage + 1
      self.end_index = self.start_index + self.showing - 1
      self.recordsLeft = self.full_count - self.end_index
      self.reloadTable()
    })
  }

  self.getTableState = function() {
    var column_params = self.collectColumnParams()
    column_params["offset"] = (self.currentPage - 1) * self.recordsPerPage
    column_params["limit"] = self.recordsPerPage
    return column_params
  }

  self.irAFichaAlumno = function(alumnoId) {
    if (store.get("user").rol === "EDITOR ATENCIONES MASIVAS") return

    appRoutesService.irAFichaAlumno(alumnoId)
  }

  self.openMenu = function($mdOpenMenu, ev) {
    $mdOpenMenu(ev)
  }
}

angular.module("appModule").component("listaAlumnos", {
  templateUrl: templateUrl,
  bindings: {
    verFicha: "&"
  },
  controller: ListaAlumnosController
})
